<p-floatlabel variant="on" class="w-100-p">
    <p-datepicker
        [formControl]="control"
        inputId="templatedisplay"
        [showIcon]="true"
        [dateFormat]="dateFormat"
        iconDisplay="input"
        [required]="required"
        [showIcon]="showCalenderIcon"
        [showTime]="isTimeShow"
        [hourFormat]="24"
        [hideOnDateTimeSelect]="false"
        [firstDayOfWeek]="1"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [appendTo]="appendTo"
        [tabindex]="tabindex"
        #calendar
    >
        <ng-template #inputicon let-clickCallBack="clickCallBack">
            <i
                *ngIf="control.value && showClearButton"
                class="pi pi-times mb-8 font-weight-900 font-size-14 color-black-60 cursor-pointer"
                (click)="control.setValue(null)"
            >
            </i>
            <i *ngIf="!(control.value && showClearButton)" class="pi pi-calendar" (click)="clickCallBack($event)"> </i>
        </ng-template>
        <ng-template #footer *ngIf="isTimeShow && isCloseButtonRequired">
            <div
                class="pt-8 pb-8 pr-8 pl-8"
                fxLayout="row"
                fxLayoutAlign="end center"
                style="position: absolute; right: 8px; bottom: 15px"
            >
                <i class="pi pi-times" style="color: red; cursor: pointer" (click)="onClickCancel()"></i>
            </div>
        </ng-template>
    </p-datepicker>
    <label for="on_label" [ngClass]="isDisabledInput ? 'disable-input' : ''">
        {{ label }}
        <span *ngIf="required" class="text-danger">*</span>
    </label>
</p-floatlabel>
<p *ngIf="required && control?.hasError('required') && control?.touched" class="error-message">
    {{ "APP_CREATE_CASE.FIELD_REQUIRED" | translate }}
</p>
